import React from "react";
import SuspenseWrapper from "@/router/component/SuspenseWrapper";

const DailyDose = React.lazy(() => import("@/pages/dailyDose/DailyDose"));

const DailyDoseRoutes = [
  {
    path: "dailyDose",
    element: (
      <SuspenseWrapper>
        <DailyDose />
      </SuspenseWrapper>
    ),
  },
];

export default DailyDoseRoutes;
